const deviceIsMobile = () => {
  // 768px, keep in sync with theme.sass/$breakpoint-mobile
  return window.innerWidth <= 768
}

export default deviceIsMobile
